import { getTranslateByKey, isNullUndefined } from '@/main/services/utils';
import { formatCurrency } from '@/main/services/utilsNumber';
import { userIsAdmin, userIsSupplier } from '@/main/services/utilsUser';
import { useVisualIdentityReducer } from '@/main/store/visualIdentity';
import React from 'react';
import * as S from './styles';

interface ISummaryCostProps {
  shippingCost?: number
  total?: number
  deliveryBySupplier?: boolean
  hideShippingCost?: boolean
  showPrices?: boolean
}
function SummaryCost({
  shippingCost,
  total,
  deliveryBySupplier,
  hideShippingCost = false,
  showPrices = true
}: ISummaryCostProps) {
  const { visualIdentity: visualIdentityReducer } = useVisualIdentityReducer();
  const showShippingCostPrice = (userIsAdmin() || userIsSupplier()) && !deliveryBySupplier;

  const formattedShippingCost = isNullUndefined(shippingCost) ? '' : formatCurrency(shippingCost);
  const formattedTotal = isNullUndefined(total) ? '' : formatCurrency(total);
  return (
    <S.Container>
      {!hideShippingCost && (
        <>
          <p>{getTranslateByKey('quotation.shippingCost')}</p>
          <p style={{ color: visualIdentityReducer.colors.pantone2726C }}>
            {getTranslateByKey('information.shippingIncluded')}
            {showShippingCostPrice && (
              <span translate='no'>
                {` (${formattedShippingCost})`}
              </span>
            )}
          </p>
        </>
      )}
      {showPrices && (
        <>
          <S.TotalPrice>{getTranslateByKey('information.total')}</S.TotalPrice>
          <S.TotalPrice translate='no'>{formattedTotal}</S.TotalPrice>
        </>
      )}
    </S.Container>
  )
}

export default SummaryCost